import { render, staticRenderFns } from "./translates.vue?vue&type=template&id=a8f0707c&scoped=true&"
import script from "./translates.vue?vue&type=script&lang=js&"
export * from "./translates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f0707c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8f0707c')) {
      api.createRecord('a8f0707c', component.options)
    } else {
      api.reload('a8f0707c', component.options)
    }
    module.hot.accept("./translates.vue?vue&type=template&id=a8f0707c&scoped=true&", function () {
      api.rerender('a8f0707c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/translates/translates.vue"
export default component.exports